import React from 'react';
import { Box, Paper } from '@mui/material';

type Props = {
    title?: string;
    children?: React.ReactNode;
};

// The teal corner label at a section card's top-right. Its parent must be
// position: relative - shared with DynamicTableVirtual's own card (its
// sectionLabel prop), so a table section matches the other settings-style
// sections instead of being nested inside a second card.
export const SectionLabel: React.FC<{ title: string }> = ({ title }) => (
    <Box sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        background: 'var(--color-primary)',
        py: 0.75,
        pl: { xs: 3, sm: 5 },
        pr: { xs: 2, sm: 3 },
        color: '#fff',
        fontSize: 14,
        fontWeight: 600,
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 15% 100%)',
        zIndex: 3,
    }}>
        {title}
    </Box>
);

const SectionWrapper: React.FC<Props> = ({ title, children }) => {
    return (
        <Paper
            sx={{
                background: 'var(--color-page-background)',
                width: '100%',
                padding: { xs: 2, sm: 4 },
                // On a phone the 16px top padding is shorter than the corner label,
                // so content in the right column ran underneath it.
                pt: title ? { xs: 5, sm: 4 } : undefined,
                boxSizing: 'border-box',
                borderRadius: 0,
                position: 'relative',
            }}
        >
            { title && <SectionLabel title={title} /> }
            {children}
        </Paper>
    );
};

export default SectionWrapper;
